/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropentrystateentered3Inputs */

const en_dropentrystateentered3 = /** @type {(inputs: Dropentrystateentered3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entered`)
};

const de_dropentrystateentered3 = /** @type {(inputs: Dropentrystateentered3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen`)
};

/**
* | output |
* | --- |
* | "Entered" |
*
* @param {Dropentrystateentered3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropentrystateentered3 = /** @type {((inputs?: Dropentrystateentered3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropentrystateentered3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropentrystateentered3(inputs)
	return de_dropentrystateentered3(inputs)
});
export { dropentrystateentered3 as "dropEntryStateEntered" }